import Layout from '../../pages/layout'
import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets } from '../../utils/getAssets'

const Iep = ({ data }) => {
  const title = data?.title
  const bg =
    data?.backgroundImage != null
      ? retrunAssets(data?.backgroundImage[0]?.url)
      : ''
  const content = data?.content?.markup
  return (
    <Layout title={title} bg={bg}>
      {DecodeHtml({ html: content })}
    </Layout>
  )
}

export default Iep
